import { IResponseInterface } from "../interfaces/api-response.interface";
import { IToken } from "../features/auth/pages/login/interface/token.interface";
import { IUser } from "../features/auth/pages/login/interface/user.interface";
import { HttpService } from "./base.service";

export interface ITwoFactorDelivery {
  phoneHint: string;
  /** Twilio Verify accepted the send. SMS is the only channel. */
  delivered: boolean;
}

class TwoFactorService extends HttpService {
  private readonly prefix: string = "auth/2fa";

  /**
   * Redeems a code. A login challenge comes back with a session; a follow
   * request challenge comes back with a single-use verificationToken.
   */
  verify = (data: {
    challengeToken: string;
    otpCode: string;
  }): Promise<
    IResponseInterface<{
      token?: IToken;
      user?: IUser;
      verificationToken?: string;
    }>
  > => this.post(`${this.prefix}/verify`, data);

  /** Attaches a number to a pending challenge, for accounts that have none. */
  submitPhone = (data: {
    challengeToken: string;
    phone: string;
  }): Promise<IResponseInterface<ITwoFactorDelivery>> =>
    this.post(`${this.prefix}/phone`, data);

  resend = (data: {
    challengeToken: string;
  }): Promise<IResponseInterface<ITwoFactorDelivery>> =>
    this.post(`${this.prefix}/resend`, data);
}

export const twoFactorService = new TwoFactorService();
